import React from 'react'

import { TableColumn } from '../../../tables/Table'
import { useCurrentModal } from '../../../modals/ModalsContext'
import DataTable from '../../../../packages/kiti/components/table/DataTable'
import Link from '../../../../packages/kiti/components/actions/Link'
import { MapIcon, useOnClick } from '../../_helper/mapHelper'
import { usePlaceTypes } from '../../../../utils/helpers/placeTypes'

const GroupedPointsTable = () => {
  const items = useCurrentModal()
  const [placeTypes] = usePlaceTypes()
  const onClick = useOnClick()

  const remap = () => {
    if (!items?.data) return []
    return items.data.map(i => {
      return { recordId: i.recordId, name: i.name, recordType: i.recordType }
    })
  }

  const columns = [
    {
      label: '',
      dataIndex: 'recordType',
      flex: 0.5,
      render: (_name, record) => <MapIcon item={record} placeTypes={placeTypes} />
    },
    {
      label: '',
      dataIndex: 'name',
      flex: 7,
      render: (name, record) => (
        <Link onClick={() => onClick(record, placeTypes)}>
          <TableColumn bold>{name}</TableColumn>
        </Link>
      )
    }
  ]

  return <DataTable rowKey="id" columns={columns} data={remap()} inPanel size="medium" />
}

export default GroupedPointsTable
